export default "__VITE_ASSET__4Ttkfd$6__"